import { BaseViewStore } from 'core/stores';
import { action } from 'mobx';
import { UpdateBuyShippingForm } from 'modules/order/forms';
import FulfillmentOrderStore from './FulfillmentOrderStore';
import { onUpdateBuyShippingStatuses, sourceOfChange } from 'common/constants';
import { formInvalidate, translate } from 'core/utils';
import { channelType } from 'common/constants';
import _ from 'lodash';

class UpdateBuyShippingViewStore extends BaseViewStore {
	form = new UpdateBuyShippingForm({
		onSuccess: async () => {
			await this.updateBuyShippingBulk();
			this.modalParams.success();
		},
	});

	constructor(rootStore, { modalParams }) {
		super(rootStore);
		this.modalParams = modalParams;
		this.fulfillmentOrderStore = new FulfillmentOrderStore(rootStore);
	}

	@action.bound async updateBuyShippingBulk() {
		this.suspend();
		try {
			const selectedItems = [];
			this.modalParams.data.map(async selectedItem => {
				let index = _.findIndex(onUpdateBuyShippingStatuses, item => item == selectedItem.fulfillmentOrderStatusAbrv);
				if (index != -1 && selectedItem.orderChannelType == channelType.amazon) {
					selectedItems.push(selectedItem);
				}
			});
			const useBuyShipping = this.form.$('useBuyShipping').value;
			const fulfillmentOrderIds = _.map(selectedItems, item => {
				return item.id;
			});
			if (selectedItems.length > 0) {
				this.modalParams.close();
				const count = await this.fulfillmentOrderStore.updateBuyShippingBulk(
					{ fulfillmentOrderIds: fulfillmentOrderIds, useBuyShipping: useBuyShipping },
					sourceOfChange.updateBuyShippingBulk
				);
				if (count > 0) {
					this.rootStore.notificationStore.success(['UPDATEBUYSHIPPINGVIEW.SUCCESSBULK', { count: count }]);
				} else {
					this.rootStore.notificationStore.error('UPDATEBUYSHIPPINGVIEW.NOVALIDORDERSELECTED');
				}
			} else {
				this.rootStore.notificationStore.error('UPDATEBUYSHIPPINGVIEW.NOVALIDORDERSELECTED');
			}
		} catch (err) {
			formInvalidate({ form: this.form, err });
		}
		this.resume();
	}
}

export default UpdateBuyShippingViewStore;
